import { makeGoalCalculator } from "./makeGoalCalculator";

export default makeGoalCalculator({
  key: "dream-vacation",
  title: "Dream Vacation",
  description: "Plan that dream trip — inflate today's cost and size the monthly SIP to fund it in time.",
  labels: {
    presentCost: "Current cost of the vacation",
    years: "Years until dream vacation",
    currentSavings: "Current savings for the vacation",
  },
  defaults: { presentCost: 5_00_000, yearsToGoal: 3 },
});
